import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({ title, subtitle, moreTo, moreLabel = "查看全部" }: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div>
        <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}